
import {
  ITPMEventStandardCalculatorClientExtension,
  ITPMEventStandardCalculatorClientExtensionProvider
} from "../../PA.TPM.Core/PA.TPM.IF.TPM.Event.Aspects";
import * as _ from 'lodash'
import {ASync} from "../../PA.Core/Basic/ASync";
import {EventStandardCalculatorExtDefault} from "./EventStandardCalculatorExtDefault";

let availableExtensions: ITPMEventStandardCalculatorClientExtension[] = [
  EventStandardCalculatorExtDefault
]


let TPMEventStandardCalculatorExtProvider: ITPMEventStandardCalculatorClientExtensionProvider = {


  get TPMEventStandardCalculatorExtensions(): Promise<ITPMEventStandardCalculatorClientExtension[]> {
    return ASync.resolve( _.clone(availableExtensions))
  },

  getTPMEventStandardCalculatorExtension(anExtensionId: string): Promise<ITPMEventStandardCalculatorClientExtension> {

    return new Promise<ITPMEventStandardCalculatorClientExtension>((resolve, error) => {


      _.forEach(availableExtensions, (anExt) => {
        if(anExt.id == anExtensionId){
          resolve(anExt)
          return
        }
      })

      resolve(undefined)
    })
  }

}

export {TPMEventStandardCalculatorExtProvider}